import { useState } from 'react';
import { motion } from 'framer-motion';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';

interface ILinkReferralPopupProps {
  onClosePopup: () => void;
  onLinkAccount: (referralLink: string) => void;
  isLoading: boolean;
  errorMessage: string;
}

export const LinkReferralPopup = ({
  onClosePopup,
  onLinkAccount,
  isLoading,
  errorMessage,
}: ILinkReferralPopupProps) => {
  const [referralLink, setReferralLink] = useState('');

  return (
    <ConfirmPopup
      closePopup={onClosePopup}
      title="Enter Referral Link"
      description="If an office or a professional has referred you, enter their link below and you each will receive an e-gift card as a thank you from GoTu!"
      descriptionStyle={{ color: colors.neutral[500], marginBottom: 32 }}
      rightButtonText="Link Account"
      rightButtonAction={() => onLinkAccount(referralLink)}
      rightButtonDisabled={!referralLink || isLoading}
      rightButtonStyle={{ marginTop: 32 }}
    >
      <input
        className="input-field"
        type="text"
        value={referralLink}
        placeholder="Referral Link"
        onChange={(e) => setReferralLink(e.target.value)}
        style={{
          width: '80%',
          maxWidth: '-webkit-fill-available',
          borderRadius: 10,
        }}
      />

      <motion.p
        initial="hide"
        animate={errorMessage ? 'show' : 'hide'}
        variants={{
          show: { opacity: 1, y: 0 },
          hide: { opacity: 0, y: -5 },
        }}
        style={{
          width: '100%',
          margin: 0,
          marginTop: 16,
          textAlign: 'center',
        }}
      >
        <Typography as="span" color={colors.error[500]}>{errorMessage}</Typography>
      </motion.p>
    </ConfirmPopup>
  );
};
